/* Updated Topbar: Replaced Import/Export with Profile controls */
import React, { useState, useMemo } from 'react';
import SafeIcon from '../../common/SafeIcon';
import { useStore } from '../../store/StoreContext';
import { useNavigate, NavLink } from 'react-router-dom';

export const Topbar = () => {
  const { state, logout } = useStore();
  const [search, setSearch] = useState('');
  const [showResults, setShowResults] = useState(false);
  const navigate = useNavigate();

  const results = useMemo(() => {
    if (!search || search.length < 2) return [];
    const query = search.toLowerCase();
    const matches = [];
    
    Object.values(state.projects).forEach(p => {
      if (p.name.toLowerCase().includes(query)) matches.push({ ...p, type: 'Project', icon: 'Folder', link: '/gantt' });
    });
    
    Object.values(state.taskTemplates).forEach(t => {
      if (t.name.toLowerCase().includes(query)) matches.push({ ...t, type: 'Task', icon: 'CheckSquare', link: '/library/tasks' });
    });

    Object.values(state.businessUnits).forEach(bu => {
      if (bu.name.toLowerCase().includes(query)) matches.push({ ...bu, type: 'Business Unit', icon: 'Briefcase', link: '/business-units' });
    });

    return matches.slice(0, 5);
  }, [search, state]);

  return (
    <div className="h-16 bg-base-900 border-b border-base-700 flex items-center justify-between px-8 shrink-0 z-40">
      <div className="relative">
        <div className="flex items-center bg-base-800 rounded-md px-3 py-1.5 w-96 border border-base-700 focus-within:border-primary transition-colors">
          <SafeIcon name="Search" className="w-4 h-4 text-gray-500 mr-2" />
          <input
            type="text"
            placeholder="Search everything..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onFocus={() => setShowResults(true)}
            onBlur={() => setTimeout(() => setShowResults(false), 200)}
            className="bg-transparent border-none outline-none text-sm text-white w-full placeholder-gray-500"
          />
        </div>

        {showResults && results.length > 0 && (
          <div className="absolute top-full left-0 w-full mt-2 bg-base-800 border border-base-700 rounded-lg shadow-2xl overflow-hidden py-2 z-50">
            {results.map((res, i) => (
              <button
                key={i}
                className="w-full px-4 py-2 hover:bg-base-700 flex items-center gap-3 text-left transition-colors"
                onClick={() => {
                  navigate(res.link);
                  setSearch('');
                }}
              >
                <div className="p-1.5 bg-base-900 rounded-md text-primary">
                  <SafeIcon name={res.icon} className="w-4 h-4" />
                </div>
                <div>
                  <div className="text-sm font-medium">{res.name}</div>
                  <div className="text-[10px] text-gray-500 uppercase tracking-widest">{res.type}</div>
                </div>
              </button>
            ))}
          </div>
        )}
      </div>

      <div className="flex items-center gap-4">
        {/* Profile Section moved from Sidebar */}
        <NavLink 
          to="/profile" 
          className="flex items-center gap-3 p-1.5 pr-4 bg-base-800 hover:bg-base-700 rounded-full border border-base-700 hover:border-primary transition-all group"
        >
          <img 
            src={state.currentUser?.avatar || `https://ui-avatars.com/api/?name=${state.currentUser?.name}&background=6C63FF&color=fff`} 
            className="w-8 h-8 rounded-full border border-base-600 object-cover shadow-sm group-hover:scale-105 transition-transform" 
            alt="Profile" 
          />
          <div className="hidden md:block">
            <div className="text-[11px] font-bold text-white leading-none mb-0.5">{state.currentUser?.name}</div>
            <div className="text-[9px] text-gray-500 uppercase tracking-widest leading-none font-bold">{state.currentUser?.role}</div>
          </div>
        </NavLink>

        <div className="h-6 w-px bg-base-700 mx-1" />

        <button 
          onClick={logout}
          className="p-2 text-gray-500 hover:text-red-400 hover:bg-red-400/10 rounded-lg transition-all"
          title="Logout"
        >
          <SafeIcon name="LogOut" className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};